import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { IBreakdown } from  '@/interfaces/insightsp2';
import { numberFormatter } from  '@/helpers/Numbers';
import BreakdownContent from './BreakdownContent'
import ModalWrapper from  '@/components/modals/ModalWrapper';
import { container, TYPES } from "@/inversifyconfig/container.config";
import { IApiSettings, IHttpRequest } from  '@/interfaces/IHttp';
import { IInsightsContext, InsightsContext } from '@/context/InsightsContext';
import { BuildPath } from  '@/helpers/Paths';
import  '@/css/breakdownModal.scss';
import Icon from '../icons/Icons';
import { IconLibrary } from  '@/interfaces/IconLibrary';

const Breakdown = ({data, queryString}: {data:IBreakdown[], queryString:string}) => {

    const [modalOpen, setModalOpen] = useState<boolean>(false);
    const [selectedBreak, setSelectedBreak] = useState<IBreakdown>(null);
    const [selectedData, setSelectedData] = useState(null);

    // Context 
    const context:IInsightsContext = useContext(InsightsContext);

    // API
    const apiSettings = container.get<IApiSettings>(TYPES.IApiSettings);

    useEffect(() => {

        if (selectedBreak){

            context.setLoading(true);

            container.get<IHttpRequest>(TYPES.IHttpRequest).get(urlBuilder(false)).then((x) => {
                
                setSelectedData(x.data.data);

            }).then(() => {

                setModalOpen(true);
                context.setLoading(false);
                
            })
            .catch((error) => {
                console.log(`Breakdown detail: ${error}`)
            })
            .finally(() => {
                context.setLoading(false);
            })

        }

    },[selectedBreak]);

    // Inform context of render finished for loading
    useLayoutEffect(() => {
        context.loadTracker.dispatch({type: 'increment'})
    }, [data]);

    function openBreak(item:IBreakdown){
        setSelectedBreak(item);
        setModalOpen(true);
    }

    function closeBreak():void{
        setModalOpen(false);
        setSelectedBreak(null);
        setSelectedData(null);
    }

    function urlBuilder(csv:boolean):string {

        const query = `${queryString}&insightsContentType=${selectedBreak.contentType}`;

        return csv ? `insights/content-details-csv?${query}` : `insights/content-details?${query}`
    }

    if (!data){
        return null
    }

    return (

        <>
            <div className="breakdown">

                <ul>
                    {data.map((item, idx) => {
                        return(
                            <li key={idx} className={item.ref} onClick={() => openBreak(item)}>
                                {(item.ref === "likes") 
                                    ? (<Icon className='image' iconName={IconLibrary.LIKE_ACTIVE} color='#106DE0' sizeInPx='32'/>) 
                                    : (<img className="image" src={item.image} alt={""} />)
                                }      
                                <span className="number">{numberFormatter(item.number)}</span>
                                <span className="label">{item.label}</span>                 
                            </li>
                        )
                    })}    
                </ul>

            </div>

            {(modalOpen && selectedBreak && selectedData) &&
                <ModalWrapper isOpen={modalOpen} onRequestClose={() => closeBreak()} className="content-details">

                    <div className="breakdown-details">

                        <div className="title">
                            {selectedBreak.label === "Likes"
                                ?   <Icon iconName={IconLibrary.LIKE_ACTIVE} className="tbl-icon" sizeInPx='18' color='#106DE0'/>
                                :   <img className="image" src={selectedBreak.image} alt={selectedBreak.label} />
                            }
             
                            <h2>{selectedBreak.label}</h2>
                        </div>

                        {selectedData.length ? 
                         
                            <>
                                <BreakdownContent data={selectedData} selectedBreak={selectedBreak} />

                                <div className="download">
                                    <a className="download-stats" href={`${apiSettings.apiBaseUrl()}${urlBuilder(true)}`}  aria-label='Download'> 
                                        <span>Download</span>
                                        <img src={`${BuildPath()}/images/insightsp2/DownloadStatsBtn.svg`} alt="" />
                                    </a>
                                </div>
                            </>
                        
                        : <div className="no-results">No data available for this insight</div>}              

                    </div>

                </ModalWrapper>
            }
        </>

    );
};

export default Breakdown;